module.exports = __webpack_public_path__ + "img/phone-generic.31aa3be.webp";